export { default } from "./Stack-component";
